/*
 * @Descripttion : vue3中央事件总线 bus （为保持和vue2版本中使用bus一致，emit,on,off前面都加了$）
 * @Author       : pishengjun
 * @Date         : 2021-09-01 18:53:55
 * @LastEditors  : pishengjun
 * @LastEditTime : 2021-11-23 22:59:17
 * @FilePath     : \registeration-examinee-pc\src\utils\bus.ts
 */

class Bus {
	list: { [key: string]: Array<any> };
	constructor() {
		// 收集订阅信息,调度中心
		this.list = {};
	}

	// 订阅
	$on(name: string, fn: any) {
		this.list[name] = this.list[name] || [];
		this.list[name].push(fn);
	}

	// 发布
	$emit(name: string, data?: any) {
		const resList = [] as any
		if (this.list[name]) {
			this.list[name].forEach((fn: any) => {
				resList.push(fn(data))
			});
		}
		return resList
	}

	// 取消订阅
	$off(name: string) {
		if (this.list[name]) {
			delete this.list[name];
		}
	}
}
export default new Bus();